import { PayloadAction } from '@reduxjs/toolkit';
import {
  checkVposReqBodyData,
  formNames,
  getBinListReqBodyData,
  onGetCommissionByBinNumberReqBodyData,
  vsPosBeldimReqBodyData,
} from 'Config';
import {
  MasterpassTokenModel,
  OnGetCommissionByBinNumberModel,
  GetBinListModel,
  CheckVposPaymentModel,
  ResultType,
  ResendCustomerCardModel,
  MasterpassAccountKeyType,
  MasterpassJwtClaims,
} from 'Models';
import {
  checkVposPayment,
  checkVposPaymentForMobile,
  extractMasterpassToken,
  isMasterpassVersion2,
  onGenerateTLVToken,
  onGetCommissionByBinNumber,
  resendCustomerCard,
} from 'Services/Queries';
import {
  onGetCreditCardListSuccess,
  onGetMasterpassTokenRequest,
  onGetMasterpassTokenRequestFail,
  onGetMasterpassTokenRequestSuccess,
  onGetCommissionByBinNumberRequest,
  onGetCommissionByBinNumberRequestSuccess,
  onGetCommissionByBinNumberRequestFail,
  onGetCreditCardListFail,
  onDeleteMasterPassSuccess,
  onDeleteMasterPassRequest,
  onDeleteMasterPassFail,
  vsPosBelbimPaymentRequest,
  vsPosBelbimPaymentRequestSuccess,
  vsPosBelbimPaymentRequestFail,
  open3DSecureModal,
  getBinListRequest,
  getBinListRequestSuccess,
  getBinListRequestFail,
  checkPaymentStatusRequest,
  close3DSecureModal,
  checkPaymentStatusRequestResult,
  setMasterPassAccountStatus,
  creditCardTransactionsStore,
  setLoadingForMasterpass,
  onGetMasterpassForMobileRequest,
  onGetMasterpassForMobileRequestSuccess,
  onGetMasterpassForMobileRequestFail,
  setUserTemporaryCreditCard,
  setTempMasterPassCardActive,
  setTempMasterPassCard,
  set3DSecureUrl,
  setThreeDSecureFlow,
  setPendingOtpFlow,
  refreshCreditCardListRequest,
  recurringOrderCompleted,
  cardRegistrationCompleted,
  masterpass3DFlowCompleted,
} from './slices';
import { put, takeLatest, call, take, select } from 'redux-saga/effects';
import { channel } from 'redux-saga';
import {
  formatCardBinNumber,
  generateRequestReferenceNumber,
  getMasterpassErrorTrace,
  getMasterpassResponseCode,
  getMasterpassResponseDescription,
  isBelbimRequestSuccess,
  isMasterpassCardRegistrationOtpRequired,
  isMasterpassOtpRequired,
  getEnvironment,
  isMasterpassSuccess,
  maskCreditCardNumber,
  MasterPassAccountStatusEnum,
  MasterpassResponseCodeEnum,
  MasterPassTokenEnum,
  sendEVAMCustomEvent,
  turkishCharacterNormalize,
} from 'Utils';
import { closeOTPDialog, showOTPDialog } from 'Stores/Dialog';
import { setFormError } from 'Stores/Form';
import { CreditCardTransactionsState, MasterPassTokenActionType } from './types';
import { storeWelcome, WelcomeState } from 'Stores/Welcome';
import { goBack, push, RouterState, replace } from 'connected-react-router';
import {
  isMasterpassPaymentTokenType,
  masterPassListCardNormalize,
  masterPassPaymentDetailsNormalize,
  masterpassTokenNormalize,
} from 'Normalize';
import { defaultTerminalGroupId, getMasterpassAdapter, MasterpassAdapter, toMasterpassVersion } from 'Utils/Masterpass';
import { UserState, userStore } from 'Stores/User';
import { showToastify } from 'Stores/Toastify';
import { VsPosBelbimReq } from 'Services/Mutations';
import { getBinList } from 'Services/Queries';
import { staticErrorMessage } from 'Stores/App/sagas';
import {
  CardTransactionsState,
  onGetCardListRequest,
  setAutomaticInstructionStep,
  setUploadSubscriptionStep,
  setUploadTLStep,
  storeCardTransactions,
} from 'Stores/CardTransactions';
import { routePath } from 'Navigator/routes';
import { BinItem } from 'Models/GetBinListModel';
import { ApplicationProcessState, applicationStore, resetCardApplicationStatus, setStep } from 'Stores/CardApplication';
import EVAMSdkEventTypes from 'Utils/EVAMSdkEventTypes';
import moment from 'moment';
import { formatDate } from 'Utils/FormatDate';

const resultChannel = channel();

/**
 * Kart listesi çağrısı başarısız olduğunda yeniden denemeden önce beklenecek süre.
 *
 * Sayfa geçişlerinde aynı başarısız isteğin tekrar tekrar atılmasını engeller;
 * yine de kalıcı olarak bloklamaz, kullanıcı biraz sonra tekrar deneyebilir.
 */
/**
 * 3D akışının biteceği kendi dönüş sayfamızın adresi.
 * `public/masterpass-3d-return.html` — CRA tarafından derlenmez, olduğu gibi sunulur.
 */
export const masterpass3DReturnUrl = () => `${window.location.origin}/masterpass-3d-return.html`;

/**
 * JWT servisi başarısız olduğunda ortak hata yönetimi.
 *
 * Oturum süresi dolduysa (505/506/507) kullanıcı karşılama sayfasına ya da
 * MiniApp girişine yönlendirilir; ayrıca kullanıcının içinde bulunduğu akışın
 * formuna hata kodu basılır.
 *
 * Eski kodda bu blok hem `REGISTER` case'i içinde hem de dışarıda tekrarlanıyordu;
 * `REGISTER` içindeki kopya erişilemez durumdaydı (oraya yalnızca istek başarılıyken
 * giriliyordu), bu yüzden tek noktada toplandı.
 */
/**
 * JWT servisi hata döndüğünde hatayı DOĞRU forma yönlendirir.
 *
 * ⚠️ Hata, `Stores/Form` içinde TEK bir `{ errorCode, formName }` çifti olarak
 * tutulur; sonraki `setFormError` bir öncekini EZER. Bu yüzden formu doğru
 * seçmek şart — yanlış form adı yazıldığında hata hiçbir ekranda görünmez.
 *
 * ⚠️ Eskiden form yalnızca akış bayraklarından (TL yükleme / abonman / talimat /
 * başvuru) seçiliyordu. Kart ekleme ekranına bu akışların İÇİNDEN girilebiliyor
 * ("Kartına TL yüklemek için bir kart gir"): kullanıcı `AddCreditCard`
 * sayfasında ama `isUserInUploadTLProcess` true olduğu için hata
 * `addBalanceToCard` formuna yazılıyordu. O sayfa
 * `FormErrorWrapper formName={formNames.addCreditCard}` kullandığından hata
 * ekrana HİÇ düşmüyor, "devam et"e basınca hiçbir şey olmuyormuş gibi
 * görünüyordu. Artık form, işlemin tipinden seçiliyor: kart işlemleri
 * (ekleme/listeleme/silme/hesap durumu) her zaman kart ekleme formuna gider.
 */
const CARD_OPERATION_TOKEN_TYPES: MasterPassTokenEnum[] = [
  MasterPassTokenEnum.CHECK_MASTERPASSS,
  MasterPassTokenEnum.REGISTER,
  MasterPassTokenEnum.CARD_LIST,
  MasterPassTokenEnum.DELETE_CARD,
  MasterPassTokenEnum.LINK,
];

const resolveTokenFailureFormName = (tokenType: MasterPassTokenEnum | undefined, cardState: CardTransactionsState) => {
  if (tokenType && CARD_OPERATION_TOKEN_TYPES.includes(tokenType)) {
    return formNames.addCreditCard;
  }
  if (cardState.isUserInUploadTLProcess) {
    return formNames.addBalanceToCard;
  }
  if (cardState.isUserInUploadSubscriptionProcess) {
    return formNames.uploadSubscription;
  }
  if (cardState.isUserInAutomatiInstructionProcess) {
    return formNames.loadAutomaticInstructions;
  }
  if (cardState.isUserInCardApplicationProcess) {
    return formNames.paymentStep;
  }
  return formNames.addCreditCard;
};

function* handleMasterpassTokenFailure(
  responseCode: string,
  errorMessage: string,
  isMiniApp: boolean,
  cardState: CardTransactionsState,
  tokenType?: MasterPassTokenEnum
) {
  const isSessionExpired = responseCode === '505' || responseCode === '506' || responseCode === '507';

  if (isSessionExpired) {
    if (!isMiniApp) {
      yield put(push(routePath.welcome));
      yield put(
        setFormError({
          errorCode: responseCode,
          formName: formNames.creditCardDetail,
        })
      );
    } else {
      const { protocol, host } = window.location;
      window.location.href = `${protocol}//${host}/mini-app`;
    }

    yield put(onGetMasterpassTokenRequestFail(errorMessage));
    return;
  }

  yield put(setFormError({ errorCode: responseCode, formName: resolveTokenFailureFormName(tokenType, cardState) }));
  // Form hatası yanlış ekrana denk gelse bile kullanıcı sessiz kalmasın.
  yield put(showToastify({ toastMessage: errorMessage || staticErrorMessage, type: 'error' }));

  yield put(onGetMasterpassTokenRequestFail(errorMessage));
}

/**
 * Kart kaydı tamamlandığındaki ortak son adımlar.
 *
 * İki farklı yoldan tetiklenir ve ikisinde de aynı şeyin olması gerekir:
 *
 *  1. SMS OTP akışı (`5001`/`5008`) — `verifyOtp` başarılı döndüğünde saga içinden.
 *  2. ACS akışı (`5010`) — kullanıcı doğrulamayı Masterpass'in kendi sayfasında
 *     tamamladığında; bitişi `AddCreditCard` kart listesini yoklayarak anlar.
 *
 * Eskiden bu blok yalnızca OTP dalının içinde, saga'ya gömülü bir closure'dı;
 * ikinci yoldan çağrılamadığı için ayrı bir action'a bağlandı.
 */
function* handleCardRegistrationCompleted() {
  const userData: UserState = yield select(userStore);
  const cardStore: CreditCardTransactionsState = yield select(creditCardTransactionsStore);
  const cardState: CardTransactionsState = yield select(storeCardTransactions);

  const { masterPassAccountStatus } = cardStore;

  // ⚠️ `onGetMasterpassTokenRequest` DEĞİL. O action `takeLatest` ile dinlendiği
  // için, aşağıdaki navigasyonun ardından varış ekranının mount'ta attığı token
  // isteği bu tazelemeyi iptal ediyordu. Ayrı action kendi watcher'ında çalışır.
  yield put(refreshCreditCardListRequest());

  yield put(closeOTPDialog());
  yield put(close3DSecureModal());
  // Akış bitti: bayrak temizlenir, yoksa sonraki OTP yanlış dala sapar.
  yield put(setPendingOtpFlow(undefined));
  yield put(setLoadingForMasterpass(false));
  yield put(setTempMasterPassCardActive());

  if (masterPassAccountStatus) {
    yield put(setMasterPassAccountStatus(''));
  }

  if (cardState.isUserInUploadTLProcess) {
    yield put(push(routePath.addBalanceToCard));
  } else if (cardState.isUserInUploadSubscriptionProcess) {
    yield put(push(routePath.uploadSubscription));
  } else if (cardState.isUserInCardApplicationProcess) {
    // PaymentStep'in doğru index'ine yönlendirme CardApplicationSteps component'inde yapılıyor
    yield put(onGetCardListRequest({ CustomerNumber: userData.customerNumber, SessionToken: userData.sessionToken }));
    // replace kullanarak history stack'ten AddCreditCard'ı kaldırıyoruz, böylece geri gitme butonuyla AddCreditCard'a dönülmez
    yield put(replace(routePath.cardApplicationSteps, { fromAddCreditCard: true }));
  } else {
    yield put(
      showToastify({
        toastMessage:
          masterPassAccountStatus === MasterPassAccountStatusEnum.NO_LINKED
            ? 'web_masterpass_link_success_msg'
            : 'web_msg_succes_add_credit_card',
        type: 'success',
      })
    );
    if (masterPassAccountStatus !== MasterPassAccountStatusEnum.NO_LINKED) {
      yield put(goBack());
    }
  }
}

/**
 * 3D akışı bittikten sonraki ÖDEME TAMAMLAMA adımı.
 *
 * ⚠️ Bu adım yeni SDK ile geldi ve atlanırsa ödeme sessizce yarım kalır:
 * 3D başarıyla biter, banka `cavv` üretir, dönüş gövdesinde `isSuccess: True`
 * yazar — ama `paymentReceived: 0`'dır ve mesaj şudur:
 *
 *   "İşlem başlatıldı, işlemin sonuçlanması için ödeme tamamlama servisi
 *    (Compelete Payment) çağırınız."
 *
 * Tamamlama yapılmadığı sürece `RI.CheckVposPayment` sonsuza kadar
 * `IsSuccess: false` döner; ekranda 3D modalı açık kalır ve kullanıcı tahsil
 * edilmemiş bir işlemle baş başa kalır.
 *
 * ⚠️ TAMAMLAMA SUNUCU TARAFINDA YAPILIR — bu fonksiyon onu ÇAĞIRMAZ.
 * Masterpass dokümanı (3D Secure): "Üye işyeri, ödemeyi tamamlamak için response
 * token değeri ile birlikte server-side CompletePayment isteği göndermelidir."
 * Masterpass 3D sonucunu `returnUrl` olarak verilen SUNUCU ucuna POST ediyor;
 * tahsilatı o uç yapıyor. Frontend yalnızca 3D'nin bittiğini öğrenir ve sonucu
 * `RI.CheckVposPayment` ile takip eder.
 */
function* handleMasterpass3DFlowCompleted({ payload }: PayloadAction<{ responseCode: string; token?: string }>) {
  // 3D başarısızsa tamamlama çağrısının anlamı yok; modalı kapatıp hatayı göster.
  if (payload?.responseCode !== MasterpassResponseCodeEnum.SUCCESS) {
    yield put(close3DSecureModal());
    yield put(setLoadingForMasterpass(false));
    yield put(showToastify({ toastMessage: staticErrorMessage, type: 'error' }));
    return;
  }

  const creditCardStore: CreditCardTransactionsState = yield select(creditCardTransactionsStore);
  const flow = creditCardStore.threeDSecureFlow;

  // ⚠️ KART KAYDI — tamamlama çağrısı YAPILMAZ.
  // SDK demosu (`addCardToMasterPass.html`) `5010`'da yalnızca `url3d`'ye
  // yönlendiriyor; kayıt o akışın sonunda zaten tamamlanıyor. Geriye listeyi
  // tazeleyip akışa göre yönlendirmek kalıyor.
  if (flow === 'cardRegistration') {
    yield put(cardRegistrationCompleted());
    return;
  }

  // ⚠️ ÖDEME AKIŞLARINDA (hem `payment` hem `directPayment`) BURADAN HİÇBİR
  // TAMAMLAMA ÇAĞRISI YAPILMAZ.
  //
  // Masterpass dokümanı (3D Secure): "Üye işyeri, ödemeyi tamamlamak için
  // response token değeri ile birlikte SERVER-SIDE CompletePayment isteği
  // göndermelidir ve bu adımda finansal işlem tamamlanmaktadır."
  //
  // Yani tahsilatı üye işyerinin SUNUCUSU yapıyor: Masterpass 3D sonucunu
  // `returnUrl` olarak verilen sunucu ucuna POST ediyor, sunucu oradaki `token`
  // ile `CompletePayment` çağırıyor. Frontend'in bu adımda yapabileceği bir şey
  // yok; sonucu `RI.CheckVposPayment` yoklamasıyla öğreniyoruz.
  //
  // ⚠️ Bir dönem burada `accountService.completeRegistration` çağrılıyordu ve
  // `404 TOKEN_IS_NOT_VALID` alınıyordu. O servis ödeme tamamlama DEĞİL: adı
  // üstünde, kaydetmeden yapılan bir ödemenin ardından KARTI KAYDETME adımıdır
  // (`directpurchase.html` demosundaki "complete" formu kart adı istiyor).
  // Ödeme token'ıyla çağrıldığı için de haklı olarak reddediliyordu.
  //
  // ⚠️ 3D Pay modelinde bu adım gerekmiyor; dokümana göre iki modelin temel farkı
  // bu. Üye işyeri hangi modeldeyse davranış ona göre değişir.
}


/**
 * Talimat kaydı tamamlandığındaki adımlar.
 *
 * Kart kaydından farkı: liste tazeleme ve geçici kart aktifleştirme yok; kullanıcı
 * talimat akışının başarı adımına geçirilir.
 */
function* handleRecurringOrderCompleted() {
  // Akış bitti: bayrak temizlenir, yoksa sonraki kart kaydı OTP'si talimat
  // bitişine sapar (kart kaydolur ama liste tazelenmez, seçili kart oluşmaz).
  yield put(setPendingOtpFlow(undefined));
  yield put(closeOTPDialog());
  yield put(setLoadingForMasterpass(false));
  yield put(setAutomaticInstructionStep(2));
}

/**
 * Tüm Masterpass akışlarının tek giriş noktası.
 *
 * ⚠️ SDK v1.0.7 ile kimlik modeli tamamen değişti:
 *
 *  - ESKİ: her işlem için ayrı bir TLV token alınır (`RI.OnGenerateTLVToken`),
 *    token + telefon numarası her isteğin gövdesine elle konurdu.
 *  - YENİ: `RI.OnGenerateJwtoken`'dan alınan JWT ile SDK bir kez yetkilendirilir
 *    (`Masterpass.setToken` + `setMerchantId`); telefon (`accountKey`) ve
 *    kullanıcı kimliği (`userId`) JWT claim'lerinden okunur, gövdeye token konmaz.
 */
function* handleGetMasterpassToken({ payload }: MasterPassTokenActionType | any) {
  const store: WelcomeState = yield select(storeWelcome);
  const userData: UserState = yield select(userStore);
  const cardStore: CreditCardTransactionsState = yield select(creditCardTransactionsStore);
  const isMiniApp = userData.isMiniAppLogin;
  const cardState: CardTransactionsState = yield select(storeCardTransactions);
  const {
    isUserInUploadTLProcess,
    isUserInUploadSubscriptionProcess,
    isUserInAutomatiInstructionProcess,
    isUserInCardApplicationProcess,
  } = cardState;
  const activeSelectedCard = payload.activeSelectedCreditCard;
  delete payload.activeSelectedCreditCard;

  const { request } = payload;
  const { Cellphone, CountryCode } = store;
  const { masterPassAccountStatus } = cardStore;

  const phone = `${CountryCode.replace('+', '')}${Cellphone}`;

  // Maskeli PAN zaten maskeliyse (içinde * varsa) tekrar maskelenmez.
  const maskedPan = payload.PanMasked
    ? payload.PanMasked.includes('*')
      ? payload.PanMasked.replaceAll(' ', '')
      : maskCreditCardNumber(payload?.PanMasked, false, true).replaceAll(' ', '')
    : undefined;

  // ⚠️ Gövde, v2 geçişinden ÖNCEKİ hâliyle birebir aynıdır: payload olduğu gibi
  // gider. Servis token'ı işlem başına ürettiği için işlem bağlamına (`TokenType`,
  // `RefTrnType`, `Amount`, kart alanları) İHTİYACI VARDIR; sadeleştirilmiş gövde
  // `99 GlobalException` ile geri döner.
  // ⚠️ v1/v2 ayrımı yalnızca CEVAPTA (`IsVersion2Active`) yapılır — istekte değil.
  // Ayrıntı ve kaldırılan JWT sözleşmesinin geçmişi için bkz. normalize dosyası.
  const requestQuery = masterpassTokenNormalize(
    { ...payload, PanMasked: maskedPan },
    cardState.isDigitalActive,
    isUserInCardApplicationProcess
  );

  // ─── GEREKSİZ KART LİSTESİ ÇAĞRILARINI ENGELLE ────────────────────────────
  // Kart listesine ihtiyaç duyan dokuz ayrı sayfa (Transactions, TL yükle,
  // Abonman, Talimat, Kartlarım, Kredi Kartlarım, Ödeme adımı …) açılışta
  // koşulsuz olarak bu isteği tetikliyordu. Eski TLV mimarisinde token zaten
  // işlem başına alındığı için bu davranış makuldü; JWT'de ise her sayfa
  // açılışı boşuna bir JWT + Masterpass turu demek.
  //
  // İstek YALNIZCA liste zaten bellekteyse atlanır.
  //
  // ⚠️ BİR DÖNEM 30 SANİYELİK "YAKIN ZAMANDA DENENDİ" KİLİDİ VARDI — KALDIRILDI.
  // Amacı, kaldırılan JWT servisinin her sayfada hata vermesi yüzünden oluşan
  // tekrar fırtınasını engellemekti. Yan etkisi ağır bastı: bir kez başarısız
  // olan çağrıdan sonra 30 saniye boyunca HİÇBİR İSTEK ATILMIYOR, kullanıcıya da
  // hiçbir şey gösterilmiyordu. Ekran sessizce boş kalıyor, sorunun kendisi mi
  // yoksa kilit mi olduğu anlaşılamıyordu.
  //
  // Sessiz hiçbir-şey-yapmama, fazladan bir istekten daha kötüdür.
  //
  // Listeyi bayatlatan işlemler (kart ekleme/silme) `forceRefresh` ile geldiği
  // için bellekteki liste de her hâlükârda tazelenir.
  if (payload.TokenType === MasterPassTokenEnum.CARD_LIST && !payload.forceRefresh) {
    if (cardStore.creditCardList?.length) {
      yield put(setLoadingForMasterpass(false));
      return;
    }
  }

  try {
    // OTP doğrulama ve tekrar gönderim yeni bir JWT gerektirmez: SDK bu adımları,
    // kendisini tetikleyen isteğin 202 cevabında sakladığı akış durumundan
    // (`FlowDirectable`) yürütür. Araya token servisi sokmak gereksiz gecikme
    // ve fazladan hata yüzeyi doğurur.
    const requiresJwt =
      payload.TokenType !== MasterPassTokenEnum.OTP && payload.TokenType !== MasterPassTokenEnum.RESEND_OTP;

    let jwtResponse: MasterpassTokenModel | undefined;
    let claims: MasterpassJwtClaims | undefined;

    // ─── SÜRÜM SEÇİMİ ─────────────────────────────────────────────────────────
    // Aktif Masterpass sürümünü BACKEND söyler (`IsVersion2Active`). Uygulama
    // sürümü seçmez, yalnızca okur.
    //
    // ⚠️ SÜRÜM BURADA SABİTLENİR VE İŞLEM BOYUNCA DEĞİŞMEZ. Token almayan adımlar
    // (OTP doğrulama, yeniden gönderim) yeni bir sürüm bilgisi alamaz; onlar
    // işlemi başlatan adımın sakladığı sürümü kullanır. Aksi halde backend
    // anahtarı akışın ortasında çevirirse doğrulama adımı, isteği hiç görmemiş
    // bir SDK'ya gider ve akış sessizce ölür.
    let adapter: MasterpassAdapter = getMasterpassAdapter(cardStore.masterpassVersion ?? 'v2');

    // ─── TOKEN ÖNBELLEĞİ ──────────────────────────────────────────────────────
    // ⚠️ ÖNBELLEK YALNIZCA v2'DE ÇALIŞIR. v2'nin JWT'si oturumluktur ve aynı token
    // kart listeleme, kart ekleme ve ödemede geçerlidir; süresi dolmadıkça yeniden
    // kullanılır. v1'in TLV token'ı ise İŞLEM BAŞINA üretilir ve tekrar kullanılamaz —
    // v1 adaptörünün `canReuseToken` metodu her zaman `false` döndüğü için bu dal
    // v1'de hiç çalışmaz.
    //
    // v2'de yeniden kullanmanın faydası: başarılı her token çağrısı bir
    // `PaymentNumber` (sipariş numarası) üretiyor; sayfa açılışlarında token
    // tazelemek boşuna sipariş kaydı doğuruyor.
    //
    // ⚠️ Bu yalnızca hafifletmedir. Oturumda HİÇ token yokken (girişten hemen
    // sonraki ilk kart listeleme) servisin ödeme bağlamı olmadan da JWT
    // üretebilmesi gerekiyor — bu bir backend eksiği.
    const isPaymentToken = isMasterpassPaymentTokenType(payload.TokenType);

    // ⚠️ Önbellekten yeniden kullanım yalnızca AYNI KAPSAMDA yapılır.
    // Servis, ödeme tipleri (4/5/7) için farklı kapsamda token üretiyor; ödeme
    // için alınmış token kart ekleme/listeleme gibi hesap işlemlerinde
    // kullanılınca Masterpass `403 AUTHENTICATION_FAILED` döndürüyor.
    // (Canlıda gözlendi: bir ödemenin ardından yapılan kart ekleme 403 aldı.)
    // ⚠️ Hesabı DEĞİŞTİREN işlemler önbelleği kullanmaz, her zaman taze token alır.
    // Masterpass dokümanı token'ın 15 dk boyunca tekrar kullanılabildiğini söylüyor
    // ve okuma işlemlerinde (liste, hesap durumu) yeniden kullanmak gereksiz turu
    // önlüyor. Ama kart ekleme/hesap bağlama gibi tek seferlik ve hata ayıklaması
    // zor adımlarda "token bayat mıydı?" sorusunu tamamen elemek için taze alınıyor;
    // maliyeti işlem başına tek bir istek.
    const usesFreshTokenOnly =
      payload.TokenType === MasterPassTokenEnum.REGISTER || payload.TokenType === MasterPassTokenEnum.LINK;

    // Oturum: kimlik alanlarının (accountKey / userId) tek kaynağı.
    // ⚠️ v2 bunları JWT claim'lerinden okur, v1 msisdn'e sabitler — fark adaptörde.
    //
    // ⚠️ ADAPTÖRÜN OTURUMU YALNIZCA TOKEN GEREKTİRMEYEN ADIMLARDA TOHUMLANIR.
    // Adaptör durumlu: `authorize()` oturumu modül seviyesinde saklıyor ve bir
    // sonraki işleme kadar yaşıyor. Koşulsuz tohumlandığında `if (!session)`
    // koşulu bir önceki işlemden kalan oturum yüzünden hiç sağlanmıyor ve
    // TOKEN SERVİSİ HİÇ ÇAĞRILMIYORDU. Sonuçları:
    //   · `jwtResponse` boş kalıyor → 3D adresi `&returnUrl=undefined` ile
    //     kuruluyor, ACS sayfası sonucu post edemiyor ve ekran beyaz kalıyor,
    //   · v1'in TEK KULLANIMLIK TLV token'ı bir sonraki işlemde tekrar
    //     kullanılıyor.
    // OTP doğrulama ve yeniden gönderim ise kendi token'ını almaz; onlar işlemi
    // başlatan adımın oturumunu kullanmak ZORUNDA, tohumlama o yüzden korunuyor.
    let session = requiresJwt ? undefined : adapter.session;

    // ⚠️ Önbellek yalnızca token'ın tekrar kullanılabildiği sürümlerde çalışır.
    // v1'in TLV token'ı işlem başınadır ve tekrar kullanılamaz; `canReuseToken`
    // v1'de her zaman `false` döndüğü için bu dal orada hiç çalışmaz.
    if (
      requiresJwt &&
      !isPaymentToken &&
      !usesFreshTokenOnly &&
      cardStore.token &&
      !cardStore.tokenIsPaymentScoped &&
      adapter.canReuseToken(cardStore.token)
    ) {
      session = adapter.authorize({
        token: cardStore.token,
        merchantId: cardStore.merchantId,
        phone,
        customerNumber: userData.customerNumber,
      });
      claims = session?.claims;
    }

    if (requiresJwt && !session) {
      const response: MasterpassTokenModel = yield call(() => onGenerateTLVToken(requestQuery));
      jwtResponse = response;

      const { requestSuccess, errorMessage, responseCode } = isBelbimRequestSuccess(response);

      if (!requestSuccess) {
        yield call(handleMasterpassTokenFailure, responseCode, errorMessage, isMiniApp, cardState, payload.TokenType);
        return;
      }

      // ⚠️ Sürüm KARARI BURADA VERİLİR ve işlemin geri kalanı bu adaptörle yürür.
      adapter = getMasterpassAdapter(toMasterpassVersion(isMasterpassVersion2(response)));

      // ⚠️ Bağlam alanları v1 için ZORUNLUDUR: MFS her isteğe `token` ve
      // `referenceNo`'yu elle ister. v2 bunları kendi cevabından okur.
      session = adapter.authorize({
        token: extractMasterpassToken(response),
        phone,
        // ⚠️ `userId` alanını v2 müşteri numarasıyla, v1 telefonla dolduruyor —
        // ayrım adaptörde. Değer önce token cevabından, yoksa oturumdan alınır.
        customerNumber: response?.data?.CustomerNumber ?? userData.customerNumber,
        context: {
          referenceNo: response?.data?.ReqRefNumber,
          orderNo: response?.data?.PaymentNumber,
          terminalGroupId: response?.data?.MpTerminalGroupId ?? undefined,
          returnUrl: response?.data?.ReturnUrl ?? undefined,
        },
      });
      claims = session?.claims;

      if (!session) {
        // Token geldi ama çözülemedi ya da boş: SDK yetkisiz kalır ve bundan
        // sonraki her çağrı 401 döner. Sessizce devam etmek yerine burada kesiyoruz.
        yield put(showToastify({ toastMessage: staticErrorMessage, type: 'error' }));
        yield put(setLoadingForMasterpass(false));
        yield put(onGetMasterpassTokenRequestFail('Masterpass token çözümlenemedi.'));
        return;
      }
    }

    // Kimlik alanları istek gövdesine elle konmaz; tek kaynak adaptörün oturumudur.
    const accountKeyType: MasterpassAccountKeyType = session?.accountKeyType ?? 'Msisdn';
    const accountKey = session?.accountKey ?? phone;

    const userId = session?.userId ?? phone;

    /**
     * Kart kaydı TAMAMLANDIĞINDA çalışacak ortak son adım.
     *
     * ⚠️ Bu blok eskiden yalnızca OTP dalının içindeydi; oysa kart ekleme her
     * zaman OTP istemiyor. `addCard` doğrudan `0000` döndüğünde (ek doğrulama
     * gerekmeyen kart) buraya hiç uğranmıyordu: liste tazelenmiyor, geçici kart
     * aktif edilmiyor ve kullanıcıya başarı yerine hata gösteriliyordu.
     * Bu yüzden ortak fonksiyona çıkarıldı ve iki yerden de çağrılıyor.
     */
    switch (payload.TokenType) {
      case MasterPassTokenEnum.CARD_LIST:
        adapter.accountAccess({ accountKey, accountKeyType, userId }, (_, res) => {
          if (isMasterpassSuccess(res)) {
            // ⚠️ `cards` yoksa BOŞ LİSTE yazılır, eski liste bırakılmaz.
            // v1'de son kart silindiğinde cevap başarılı döner ama `cards` alanı
            // hiç gelmez; eski kod bu durumda listeye dokunmadığı için silinen
            // kart ekranda kalmaya devam ediyordu. ("Kart yok" ayrımını v2'de
            // `ACCOUNT_NOT_FOUND` yapıyor, v1'de öyle bir kod yok.)
            resultChannel.put(onGetCreditCardListSuccess(res.result?.cards ?? []));
            resultChannel.put(setLoadingForMasterpass(false));
            return;
          }

          // ⚠️ "Kart yok" ile "servis hatası" AYRI ele alınmalı.
          //
          // Son kayıtlı kart silindiğinde `accountAccess` `404 ACCOUNT_NOT_FOUND`
          // döner — bu geçerli bir boş durumdur, liste boşaltılır.
          //
          // Diğer hatalarda (ağ kopması, 5xx, token süresi) liste BOŞALTILMAZ:
          // eskiden her hata "hiç kartınız yok" olarak gösteriliyordu ve kayıtlı
          // kartı olan kullanıcı aynı kartı tekrar eklemeye çalışabiliyordu.
          if (getMasterpassResponseCode(res) === MasterpassResponseCodeEnum.ACCOUNT_NOT_FOUND) {
            resultChannel.put(onGetCreditCardListSuccess([]));
            resultChannel.put(setLoadingForMasterpass(false));
            return;
          }

          // Teşhis için ham cevabı yaz: liste boş kaldığında sorunun token mu,
          // Masterpass cevabı mı olduğunu ayırt etmenin tek yolu bu.
          //
          // ⚠️ YALNIZCA TEST ORTAMI. CRA üretim derlemesinde `console` çağrılarını
          // TEMİZLEMİYOR; bayrak olmadan bu satır canlı kullanıcının konsoluna da
          // Masterpass korelasyon kimliğini yazar.
          if (getEnvironment()) {
            console.warn(
              '[Masterpass] Kart listesi alınamadı.',
              getMasterpassErrorTrace(res),
              getMasterpassResponseDescription(res)
            );
          }
          resultChannel.put(onGetCreditCardListFail());
        });
        break;

      // Hesap durumu sorgusu ile kart listesi AYNI cevaptan gelir (`accountAccess`).
      // Kartları da buradan doldurarak ayrı bir `CARD_LIST` turundan kurtuluyoruz;
      // girişten sonra tek Masterpass çağrısı yetiyor.

      // ⚠️ Eski `MFS.checkMasterPass` metodunun yeni SDK'da karşılığı yok; hesap
      // durumu hesap erişimi cevabından türetiliyor. Türetmenin sınırları için
      // bkz. `deriveMasterpassAccountStatus`.
      case MasterPassTokenEnum.CHECK_MASTERPASSS:
        // ⚠️ `accountAccess` DEĞİL `checkAccount`: v2'de ikisi aynı cevaptan gelir
        // ama v1'de hesap durumu ayrı bir servistir (`MFS.checkMasterPass`) ve
        // kart listesi döndürmez. Durum okuma da adaptörden geçer — v1 hazır
        // string verir, v2 türetir.
        adapter.checkAccount({ accountKey, accountKeyType, userId }, (_, res) => {
          resultChannel.put(setMasterPassAccountStatus(adapter.accountStatus(res)));

          const cards = res.result?.cards;
          if (cards) {
            resultChannel.put(onGetCreditCardListSuccess(cards));
          }
          resultChannel.put(setLoadingForMasterpass(false));
        });
        break;

      case MasterPassTokenEnum.REGISTER_PURCHASE: {
        const formattedDate = formatDate(new Date());
        const data = request.data;

        // ⚠️ Sipariş/fatura/teslimat bilgisi artık `additionalParams` içindeki
        // snake_case gövdeyle DEĞİL, SDK'nın yapılandırılmış blokları ile gider.
        const paymentDetails = masterPassPaymentDetailsNormalize({
          amount: data?.amount ?? 0,
          name: userData.name,
          surname: userData.surname,
          email: userData.email,
          phoneNumber: userData.phoneNumber,
          formattedDate,
        });

        // Terminal grubu — ödeme isteğinde `terminalGroupId` alanına gider.
        //
        // ⚠️ `MacroMerchantId` DEĞİL `MpTerminalGroupId` okunur: ilki iki anlamlı
        // (v1'de terminal grubu, v2'de üye işyeri kimliği), ikincisi her iki
        // sürümde de terminal grubunu taşır. Canlı TLV cevabıyla doğrulandı —
        // v1'de iki alan aynı değeri (`05878207920408103103242`) döndürüyor.
        // ⚠️ Yedek zincirin SONU ortama duyarlı olmalı: `cardStore.mmid` bir dönem
        // ortam kontrolü olmadan TEST sabitini taşıyordu ve token cevabı terminal
        // grubunu vermediğinde canlıda test terminaline düşülüyordu.
        const terminalGroupId =
          jwtResponse?.data?.MpTerminalGroupId ??
          jwtResponse?.data?.MacroMerchantId ??
          data?.terminalGroupId ??
          cardStore.mmid ??
          defaultTerminalGroupId();

        const basePaymentRequest = {
          accountKey,
          amount: data?.amount ?? 0,
          orderNo: jwtResponse?.data?.PaymentNumber,
          ...paymentDetails,
          ...(terminalGroupId ? { terminalGroupId } : {}),
          // Ödeme bağlamı JWT claim'lerinden gelir — SDK demosu da bu alanları
          // token'dan doldurur. Gönderilmezse üye işyeri varsayılanlarına düşülür
          // ve 3D akışı beklenenden farklı davranabilir.
          ...(claims?.AuthenticationMethod ? { authenticationMethod: claims.AuthenticationMethod } : {}),
          ...(claims?.Secure3dType ? { secure3DModel: claims.Secure3dType } : {}),
          ...(claims?.CurrencyCode ? { currencyCode: claims.CurrencyCode } : {}),
        };

        const onPaymentResponse = (_: number, res: any) => {

          if (getMasterpassResponseCode(res) === MasterpassResponseCodeEnum.THREE_D_REDIRECT) {
            // ⚠️ Alan adı `url3D` değil `url3d` (küçük d) — SDK v1.0.7 ile değişti.
            //
            // ⚠️ `returnUrl` ÜYE İŞYERİNİN SUNUCU UCU OLMALI — kendi statik
            // sayfamız değil. Masterpass dokümanı: "3D doğrulama sonucu, response
            // token ve ödeme bilgilerini üye işyeri SUNUCUSUNA post etmektedir.
            // Hangi URL'e post edileceği ... response.url3d + '&returnUrl=' + ..."
            // Sunucu, POST ile gelen `token` ile server-side `CompletePayment`
            // çağırıp işlemi finansallaştırır. Adres bir süre kendi statik dönüş
            // sayfamıza çevrilmişti; o sayfa POST'u işleyemediği için tamamlama
            // hiç yapılamıyordu.
            const newUrl = `${res.url3d}&returnUrl=${jwtResponse?.data?.ReturnUrl}`;
            const vsPosBelbimPaymentResult: ResultType = {
              PaymentNumber: jwtResponse?.data?.PaymentNumber ?? '',
              url: newUrl,
            };
            resultChannel.put(vsPosBelbimPaymentRequestSuccess(vsPosBelbimPaymentResult));
            resultChannel.put(open3DSecureModal());
            resultChannel.put(setLoadingForMasterpass(false));
            return;
          }

          // ⚠️ `0000` HATA DEĞİLDİR — ödemenin BİRİNCİ adımı başarılı demektir.
          //
          // Masterpass dokümanı (Payment): "Kayıtlı kart ile ödeme akışı 2 adımdan
          // oluşmaktadır. İlk adımda ... payment methodu ile ödeme isteği iletilir.
          // Bu servisin yanıtında ... tek kullanımlık ve 15dk expire süresi olan bir
          // token değeri dönmektedir. İşyeri, token değerini kendi backend sunucusuna
          // taşıyarak, server side olarak PaymentComplete servisini çağırmalıdır."
          //
          // Yani 3D olsun olmasın tahsilat ikinci adımda gerçekleşiyor ve o adım
          // SUNUCU TARAFINDA. Burada kullanıcıya hata gösterilmemeli; sonuç
          // `RI.CheckVposPayment` yoklamasıyla öğrenilir.
          //
          // ⚠️ EKSİK: birinci adımın token'ının Belbim sunucusuna taşınacağı bir
          // servis henüz yok. 3D akışında token, Masterpass tarafından `returnUrl`
          // olarak verilen sunucu ucuna POST ediliyor; 3D'siz akışta ise token
          // yalnızca burada, istemcide duruyor ve iletilemiyor.
          if (isMasterpassSuccess(res)) {
            resultChannel.put(setLoadingForMasterpass(false));
            return;
          }

          const errorCode = getMasterpassResponseDescription(res);
          resultChannel.put(setLoadingForMasterpass(false));

          if (isUserInUploadTLProcess) {
            resultChannel.put(setFormError({ errorCode, formName: formNames.addBalanceToCard }));
          }
          if (isUserInUploadSubscriptionProcess) {
            resultChannel.put(setFormError({ errorCode, formName: formNames.uploadSubscription }));
          }
          if (isUserInAutomatiInstructionProcess) {
            resultChannel.put(setFormError({ errorCode, formName: formNames.loadAutomaticInstructions }));
          }
          if (isUserInCardApplicationProcess) {
            resultChannel.put(setFormError({ errorCode, formName: formNames.paymentStep }));
          }
        };

        // ⚠️ Kart seçimi artık maskeli PAN (`rtaPan`) ile değil kart adı
        // (`cardAlias`) ile yapılır. Ham kart numarası yalnızca Masterpass'e
        // KAYDEDİLMEMİŞ kartlarda bulunur; o durumda kayıtsız ödeme servisi kullanılır.
        //
        // ⚠️ Bu ayrım kritik: kaydedilmemiş bir kart için `payment` çağrılırsa
        // Masterpass o alias'ı bulamaz ve `CARD_NOT_FOUND` döner.
        if (activeSelectedCard?.cardNumber) {
          // ⚠️ 3D bitişinde ne yapılacağı bu ayrıma bağlı: SDK demolarında
          // `completeRegistration` YALNIZCA `directPayment` akışında çağrılıyor.
          resultChannel.put(setThreeDSecureFlow('directPayment'));
          adapter.directPayment(
            {
              ...basePaymentRequest,
              cardNumber: activeSelectedCard.cardNumber,
              expiryDate: activeSelectedCard.expiryDate,
              cvc: activeSelectedCard.cvv,
              cardAlias: activeSelectedCard.cardAlias,
            },
            onPaymentResponse
          );
        } else {
          resultChannel.put(setThreeDSecureFlow('payment'));
          adapter.payment(
            {
              ...basePaymentRequest,
              cardAlias: activeSelectedCard?.cardAlias ?? data?.cardAlias ?? '',
              cvc: activeSelectedCard?.cvv ?? data?.cvc,
            },
            onPaymentResponse
          );
        }
        break;
      }

      case MasterPassTokenEnum.DELETE_CARD:
        resultChannel.put(onDeleteMasterPassRequest());
        // ⚠️ Kart artık maskeli PAN ile değil kart adıyla siliniyor.
        adapter.removeCard({ accountKey, cardAlias: request.data.cardAlias ?? '' }, (_, res) => {
          if (isMasterpassSuccess(res)) {
            // Silinen kartın adı: liste anında güncellensin diye iletiliyor.
            resultChannel.put(onDeleteMasterPassSuccess(request.data.cardAlias));
            // ⚠️ Ayrı action — `goBack()` sonrası varış ekranının token isteği
            // bunu iptal edemesin diye (bkz. `refreshCreditCardListRequest`).
            resultChannel.put(refreshCreditCardListRequest());
            resultChannel.put(goBack());
            resultChannel.put(
              showToastify({
                toastMessage: 'web_msg_succes_delete_credit_card',
                type: 'success',
              })
            );
          } else {
            resultChannel.put(
              setFormError({
                errorCode: getMasterpassResponseDescription(res),
                formName: formNames.creditCardDetail,
              })
            );
            resultChannel.put(onDeleteMasterPassFail());
          }
        });
        break;

      case MasterPassTokenEnum.REGISTER: {
        // Kart, OTP doğrulaması bitene kadar bellekte tutulur; doğrulama başarılı
        // olunca aktif seçili kart haline gelir.
        resultChannel.put(
          setTempMasterPassCard({
            cardAlias: request.data.accountAliasName ?? '',
            // Kart henüz Masterpass'e kaydedilmedi: ham numara `cardNumber`
            // alanında tutulur ki ödeme akışı kayıtsız ödeme servisini seçebilsin.
            cardNumber: request.data.cardNumber ?? '',
            maskedCardNumber: request.data.cardNumber ?? '',
            expiryDate: request.data.expiryDate ?? '',
            cvv: request.data.cvv ?? '',
          })
        );

        if (request.type === MasterPassTokenEnum.LINK) {
          adapter.linkToMerchant({ accountKey, userId }, (_, response) => {
            resultChannel.put(setLoadingForMasterpass(false));

            // Hesap bağlama da ödeme dışı bir hesap işlemi; kart kaydıyla aynı
            // doğrulama kodlarını (`5001`/`5008`/`5010`) döndürebilir.
            if (isMasterpassCardRegistrationOtpRequired(response)) {
              // ⚠️ Bayrak AÇIKÇA yazılır — önceki akıştan kalan değere güvenilmez.
              resultChannel.put(setPendingOtpFlow('cardRegistration'));
              resultChannel.put(showOTPDialog());
            } else {
              resultChannel.put(
                setFormError({
                  errorCode: getMasterpassResponseDescription(response),
                  formName: formNames.addCreditCard,
                })
              );
            }
          });
        } else {
          adapter.addCard(
            {
              accountKey,
              accountKeyType,
              userId,
              cardNumber: request.data.cardNumber ?? '',
              expiryDate: request.data.expiryDate ?? '',
              cvv: request.data.cvv ?? '',
              accountAliasName: request.data.accountAliasName ?? '',
              cardHolderName: request.data.cardHolderName,
              // ⚠️ Eski TLV cevabındaki `ReqRefNumber` bu serviste YOK. `PaymentNumber`
              // ise yalnızca ödeme bağlamı gönderilen çağrılarda doluyor; kart ekleme
              // ödeme bağlamı taşımadığı ve JWT önbelleğe alındığında servis hiç
              // çağrılmadığı (`jwtResponse` undefined) için bu alan boş kalabiliyordu.
              // Alan zorunlu: boş gidince `REQUEST_REFERENCE_NUMBER_IS_REQUIRED` alınır.
              // ⚠️ `??` DEĞİL `||` — çağıranlar boş string gönderebiliyor ve `??`
              // onu geçerli sayıp üreticiyi atlıyor.
              requestReferenceNumber:
                request.data.requestReferenceNumber ||
                jwtResponse?.data?.PaymentNumber ||
                generateRequestReferenceNumber(),
              additionalParams: request.data.additionalParams,
            },
            (_, response) => {
              resultChannel.put(setLoadingForMasterpass(false));

              // SMS OTP adımı — doğrulama kendi dialog'umuzda yapılır.
              if (isMasterpassOtpRequired(response)) {
                // ⚠️ Bayrak AÇIKÇA yazılır — önceki akıştan kalan değere güvenilmez.
                resultChannel.put(setPendingOtpFlow('cardRegistration'));
                resultChannel.put(showOTPDialog());
                return;
              }

              // ⚠️ `5010` — doğrulama Masterpass'in KENDİ sayfasında yapılır.
              //
              // Kendi OTP dialog'umuzu kullanmayı denedik, çalışmıyor: SDK'nın
              // `verifyOtp`'si adresi `Rest.post(l.endpoint + FlowDirectable.uri)`
              // diye kuruyor, `FlowDirectable.uri` ise 202 cevabının
              // `content-location` header'ından geliyor ve MUTLAK URL dönüyor.
              // İkisi üst üste binince adres
              // `https://mp-test-sdk.masterpassturkiye.comhttps://mp-test-sdk...`
              // oluyor, tarayıcı `mp-test-sdk.masterpassturkiye.comhttps` host'unu
              // çözemeyip `ERR_NAME_NOT_RESOLVED` veriyor. Ayrıca o adres bir API
              // değil, ACS'nin HTML formu (`mp-3d-acs-form`).
              //
              // Bu yüzden SDK demosunun yolu izleniyor: `url3d` açılır. Demo tam
              // sayfa yönlendirme yapıyor; biz iframe'li modal kullanıyoruz çünkü
              // uygulamada persist yok, yönlendirme geçici kartı ve akış durumunu
              // kaybettirirdi. Kaydın tamamlanmasını `AddCreditCard` kart listesini
              // yoklayarak anlar (ACS sayfası cross-origin, iframe okunamıyor).
              if (getMasterpassResponseCode(response) === MasterpassResponseCodeEnum.THREE_D_REDIRECT) {
                // ⚠️ Alan adı `url3D` değil `url3d` (küçük d) — SDK v1.0.7 ile değişti.
                // ⚠️ `returnUrl` BURAYA DA eklenmeli. Eksik olduğunda 3D akışı
                // Masterpass'in kendi `mp-3d-client-success` sayfasında bitiyor;
                // o sayfa cross-origin olduğu için bittiğini göremiyor, kaydı
                // tamamlayan çağrıyı hiç yapamıyorduk.
                const registrationUrl3d = response.url3d ?? adapter.flow3d().url3d ?? '';
                resultChannel.put(
                  set3DSecureUrl(
                    registrationUrl3d
                      ? `${registrationUrl3d}&returnUrl=${encodeURIComponent(masterpass3DReturnUrl())}`
                      : ''
                  )
                );
                resultChannel.put(open3DSecureModal());
                return;
              }

              // ⚠️ Ek doğrulama gerektirmeyen kartlarda servis doğrudan `0000`
              // döner ve OTP dalına HİÇ uğranmaz. Eskiden bu durum da hata
              // sayılıyordu: kart Masterpass'e eklendiği hâlde kullanıcıya
              // "Kart bilgilerini kontrol edin" gösteriliyor, liste tazelenmiyordu.
              if (isMasterpassSuccess(response)) {
                resultChannel.put(cardRegistrationCompleted());
                return;
              }

              // ⚠️ HÂLÂ KARŞILIĞI OLMAYAN ADIMLAR — SDK demosu
              // (`addCardToMasterPass.html`) `addCard` için şunları da işliyor:
              //   `5013` CVV → CVV doğrulama adımı (`verifyOtp` + `validationCode`).
              //   `5000` RTA → tutar doğrulama adımı.

              // ⚠️ TEŞHİS — WEB kart ekleme hata dalında korelasyon izi yoktu.
              //
              // Mobil dalda `iz`/`hataDetay` postMessage ile native loga düşüyor
              // ama web'den test edildiğinde Masterpass'e verilecek
              // `correlationId` hiç üretilmiyordu. `exception.details` hatanın
              // hangi bacaktan geldiğini söylüyor (örn. "CryptographyService
              // error." ya da "registration/authorize → Vpos/auth-3d-secure").
              // ⚠️ YALNIZCA TEST ORTAMI — bkz. kart listesi dalındaki not.
              if (getEnvironment()) {
                console.warn(
                  '[Masterpass] kart ekleme hatası →',
                  getMasterpassErrorTrace(response),
                  response?.exception ?? {}
                );
              }

              resultChannel.put(
                setFormError({
                  // Sabit metin yerine servisin gerçek açıklaması: hangi adımda
                  // kalındığı ancak böyle görülebiliyor.
                  errorCode: getMasterpassResponseDescription(response),
                  formName: formNames.addCreditCard,
                })
              );
            }
          );
        }
        break;
      }

      // ⚠️ Bu dal eskiden BOŞTU (`break;`) — web'de otomatik talimat hiç
      // kurulmuyordu. `AutomaticInstructionApprove` içindeki gönderim de tamamen
      // yorum satırındaydı, yani "Onayla" hiçbir şey yapmıyordu.
      //
      // Masterpass dokümanı (Recurring Order Register): kayıtlı kart seçilir,
      // `recurringOrder` çağrılır, `5001` (OTP giriniz) alınır, SMS ekranı açılır,
      // 6 haneli kod `Verify` ile iletilir; doğrulama başarılı olunca talimat
      // kaydı tamamlanır.
      case MasterPassTokenEnum.RECURING_PAYMENT: {
        const recurringRequest = {
          accountKey,
          // ⚠️ `authenticationMethod` TALİMAT İSTEĞİNE KONULMAZ — DENENDİ, BOZDU.
          //
          // Masterpass'in resmi demosu bu alanı JWT'den doldurup gönderiyor
          // (Masterpass-web-sdk-main/demo/pages/recurringOrder.html), o yüzden
          // eklenmişti. Ama BİZİM talimat token'ımızda claim'in değeri literal
          // `'None'` ve bu değerle gönderildiğinde servis üç yönde de (A/U/D)
          // HTTP 401 dönüyor — daha önce çalışan TALİMAT OLUŞTURMA da kırıldı.
          //
          // Alan gönderilmediğinde servis kendi varsayılanını kullanıyor ve
          // oluşturma çalışıyor. Belbim talimat token'ına anlamlı bir
          // `AuthenticationMethod` claim'i koyana kadar bu alan GÖNDERİLMEYECEK.
          cardAlias: request.data.cardAlias ?? '',
          amountLimit: request.data.amountLimit,
          expiryDate: request.data.expiryDate,
          productId: request.data.productId,
          // ⚠️ `??` DEĞİL `||`. Çağıranlar referans numarasını BOŞ STRING olarak
          // gönderebiliyor (mobil WebView `reqRefNumber || ''` yapıyor ve v2 cevabında
          // `ReqRefNumber` hiç gelmiyor). `??` boş string'i geçerli sayıp üreticiyi
          // atlıyor, Masterpass da "Request Reference Number boş olmamalı" diyor.
          requestReferenceNumber: request.data.requestReferenceNumber || generateRequestReferenceNumber(),
          // ⚠️ v1 (MFS) gövdesi bu alanı bekliyor; v2 SDK'sı whitelist'te
          // olmadığı için sessizce siliyor. İki sürüm için de güvenli.
          ...(request.transactionFee ? { transactionFee: request.transactionFee } : {}),
        };

        const onRecurringResponse = (_: number, response: any) => {
          resultChannel.put(setLoadingForMasterpass(false));

          // Doküman: talimat kaydında `5001` (OTP) bekleniyor.
          if (isMasterpassOtpRequired(response)) {
            resultChannel.put(setPendingOtpFlow('recurringOrder'));
            resultChannel.put(showOTPDialog());
            return;
          }

          // Doğrulama istemeden tamamlandıysa akış burada biter.
          if (isMasterpassSuccess(response)) {
            resultChannel.put(recurringOrderCompleted());
            return;
          }

          // ⚠️ Talimat zaten varsa (`4152`) doküman güncelleme servisini ayrı
          // tanımlıyor; burada eski davranış korunuyor: önce sil, sonra yeniden
          // oluştur. Silmede doğrulama uygulanmıyor (doküman: Recurring Order Delete).
          if (getMasterpassResponseCode(response) === MasterpassResponseCodeEnum.RECURRING_ALREADY_EXISTS) {
            adapter.recurringOrderDelete(recurringRequest, (__, deleteResponse) => {
              if (isMasterpassSuccess(deleteResponse)) {
                adapter.recurringOrder(recurringRequest, onRecurringResponse);
                return;
              }

              resultChannel.put(
                setFormError({
                  errorCode: getMasterpassResponseDescription(deleteResponse),
                  formName: formNames.loadAutomaticInstructions,
                })
              );
            });
            return;
          }

          resultChannel.put(
            setFormError({
              errorCode: getMasterpassResponseDescription(response),
              formName: formNames.loadAutomaticInstructions,
            })
          );
        };

        adapter.recurringOrder(recurringRequest, onRecurringResponse);
        break;
      }

      case MasterPassTokenEnum.OTP:
        adapter.verifyOtp(request.data, (_, res) => {
          // ⚠️ KART KAYDI İKİ AŞAMALI DOĞRULAMA İSTEYEBİLİR.
          //
          // Masterpass dokümanı (Add Card): üye işyeri kullanıcının telefonunu
          // DAHA ÖNCE DOĞRULAMAMIŞSA `addCard` `5008` döner (Masterpass'in SMS'i).
          // O kod doğrulandığında `verify` servisi `0000` değil `5001` döner —
          // bu sefer KARTIN BANKASININ gönderdiği SMS istenir ve ikinci kez
          // doğrulama yapılır; kayıt ancak ondan sonra tamamlanır.
          //
          // Burası eskiden tek adım varsayıyordu: `5001` başarı sayılmadığı için
          // kullanıcıya ikinci SMS ekranı yerine HATA gösteriliyordu ve kayıt
          // yarım kalıyordu. Artık ikinci tur için dialog açık bırakılıyor.
          if (isMasterpassOtpRequired(res)) {
            resultChannel.put(showOTPDialog());
            resultChannel.put(setLoadingForMasterpass(false));
            return;
          }

          if (!isMasterpassSuccess(res)) {
            resultChannel.put(
              setFormError({
                errorCode: getMasterpassResponseDescription(res),
                formName: formNames.dialogOTP,
              })
            );
            resultChannel.put(setLoadingForMasterpass(false));
            return;
          }

          // ⚠️ Doğrulama BAŞARILI — ama bitişte yapılacak iş akışa göre değişir.
          // `DialogOTP` tek bileşen; talimat doğrulaması da kart kaydı sonu gibi
          // işlenirse kart listesi tazelenip yanlış ekrana yönlendirilir.
          if (cardStore.pendingOtpFlow === 'recurringOrder') {
            resultChannel.put(recurringOrderCompleted());
            return;
          }

          resultChannel.put(cardRegistrationCompleted());
        });
        break;

      case MasterPassTokenEnum.RESEND_OTP:
        // ⚠️ Eski imza `resendOtp(token, dil, cb)` idi. Yeni SDK'da token akış
        // durumundan, dil ise `Masterpass.setLanguage()` ile kurulan global
        // ayardan okunur; ikisi de parametre olarak geçilmez.
        adapter.resendOtp(() => {});
        resultChannel.put(setLoadingForMasterpass(false));
        break;

      default:
        break;
    }

    if (jwtResponse) {
      // Kapsam da saklanıyor: ödeme için alınan token hesap işlemlerinde
      // yeniden kullanılmamalı (bkz. önbellek kontrolü).
      yield put(
        onGetMasterpassTokenRequestSuccess({
          response: jwtResponse,
          isPaymentScoped: isPaymentToken,
          // ⚠️ Cevaptaki `MacroMerchantId` DEĞİL: o alan v1'de terminal grubunu,
          // v2'de üye işyerini taşıyor. Doğru değeri adaptör kendi kaynağından
          // (v2'de JWT `MerchantId` claim'i) çözüyor.
          merchantId: session?.merchantId,
        })
      );
    }
  } catch (error: any) {
    yield put(onGetMasterpassTokenRequestFail(error));
  }
}

function* handleVsPosBelbimPaymentRequest({ payload }: PayloadAction<vsPosBeldimReqBodyData>) {
  try {
    const vsPosBelbimPaymentResult: ResultType = yield call(() => VsPosBelbimReq(payload));
    yield put(vsPosBelbimPaymentRequestSuccess(vsPosBelbimPaymentResult));
    yield put(open3DSecureModal());
  } catch (error: any) {
    yield put(showToastify({ toastMessage: staticErrorMessage, type: 'error' }));
    yield put(vsPosBelbimPaymentRequestFail(error));
  }
}
function* handleCheckVposPayment({ payload }: PayloadAction<checkVposReqBodyData>) {
  try {
    const appState: ApplicationProcessState = yield select(applicationStore);
    const cardState: CardTransactionsState = yield select(storeCardTransactions);
    const userData: UserState = yield select(userStore);
    const creditCardStore: CreditCardTransactionsState = yield select(creditCardTransactionsStore);
    const routerState: RouterState = yield select((state: any) => state.router);
    let pathname = routerState?.location?.pathname;
    const {
      isUserInUploadTLProcess,
      isUserInUploadSubscriptionProcess,
      isUserInAutomatiInstructionProcess,
      isUserAddingNewCardInTransactions,
    } = cardState;
    const {
      updateApplicationId,
      applicationCard,
      isShipping,
      institutionType,
      campusId,
      cardApplicationStatus,
    } = appState;

    const vsPosBelbimPaymentResult: CheckVposPaymentModel = yield call(() => checkVposPayment(payload));

    const { requestSuccess, errorMessage } = isBelbimRequestSuccess(vsPosBelbimPaymentResult);

    if (requestSuccess) {
      yield put(checkPaymentStatusRequestResult(vsPosBelbimPaymentResult));

      if (vsPosBelbimPaymentResult.data.IsSuccess) {
        yield put(close3DSecureModal());

        if (isUserInUploadTLProcess) {
          yield put(setUploadTLStep(1));

          const selectedCreditCardBinNumber = creditCardStore?.activeSelectedCreditCard?.maskedCardNumber.slice(0, 6);

          const creditCardState: CreditCardTransactionsState = yield select(creditCardTransactionsStore);

          const creditCardBinList: BinItem[] | undefined = creditCardState.creditCardBinList;
          const findBinObject = (): BinItem | undefined => {
            const cardBinNumber = formatCardBinNumber(selectedCreditCardBinNumber);
            if (!cardBinNumber || !creditCardBinList) return undefined;

            const cardBin = parseInt(cardBinNumber, 10);

            return creditCardBinList.find((bin) => {
              const minBin = parseInt(bin.BinNumberMin, 10);
              const maxBin = parseInt(bin.BinNumberMax, 10);
              return cardBin >= minBin && cardBin <= maxBin;
            });
          };

          const activeCardInfo = findBinObject();

          let evamSdkData = {
            customer_no: userData?.customerNumber,
            kart_id: cardState?.activeSelectedCard?.CardId,
            /*  kayıtlı_kart_bilgisi: creditCardStore?.activeSelectedCreditCard,
            masterpass_ile_kayıt_bilgisi: creditCardStore?.activeSelectedCreditCard?.IsMasterPassMember
              ? creditCardStore?.activeSelectedCreditCard
              : '', */
            kart_logo_bilgisi: activeCardInfo?.BankLink,
            bin: selectedCreditCardBinNumber,
            amount: creditCardStore?.loadAmount,
            kayitli_kart_bilgisi_masterpass_ile_kayit_bilgisi: activeCardInfo?.CardBrand,
            masterpass_ile_kayit_bilgisi_IsMasterPassMember:
              creditCardStore?.activeSelectedCreditCard?.IsMasterPassMember,
            kayitli_kart_bilgisi_IsMasterPassMember: activeCardInfo?.CardBrand,
            masterpass_ile_kayit_bilgisi_CardStatus: creditCardStore?.activeSelectedCreditCard?.CardStatus,
            kayitli_kart_bilgisi_CardStatus: creditCardStore?.activeSelectedCreditCard?.CardStatus,
            masterpass_ile_kayit_bilgisi_LoyaltyCode: creditCardStore?.activeSelectedCreditCard?.LoyaltyCode,
            kayitli_kart_bilgisi_LoyaltyCode: creditCardStore?.activeSelectedCreditCard?.LoyaltyCode,
            masterpass_ile_kayit_bilgisi_ProductName: creditCardStore?.activeSelectedCreditCard?.ProductName,
            masterpass_ile_kayit_bilgisi_creditCardName: creditCardStore?.activeSelectedCreditCard?.cardAlias,
            masterpass_ile_kayit_bilgisi_value1: creditCardStore?.activeSelectedCreditCard?.maskedCardNumber,
          };
          /* sendEVAMCustomEvent(EVAMSdkEventTypes.KAYITLI_ISTANBUL_KARTA_TL_YUKLEME, evamSdkData); */

          // Kullanıcı yeni istanbulkart eklerse
          if (isUserAddingNewCardInTransactions) {
            let evamSdkData = {
              customer_no: userData.customerNumber,
              amount: creditCardStore.loadAmount,
              kart_id: cardState?.activeSelectedCard?.CardId,
              panmasked: creditCardStore?.activeSelectedCreditCard?.maskedCardNumber.slice(0, 6),
              kayıtsızkart: cardState?.activeSelectedCard,
              kanal: 'web', // TODO
            };
            /* sendEVAMCustomEvent(EVAMSdkEventTypes.HIZLI_ISLEM_ILE_BASKA_IST_KARTA_TL_YUKLEME, evamSdkData); */
          }
        }
        if (isUserInUploadSubscriptionProcess) {
          yield put(setUploadSubscriptionStep(1));
          let evamSdkData = {
            customer_no: userData.customerNumber,
            kart_id: cardState?.activeSelectedCard?.CardId,
            tarih: moment(new Date()).format('DD.MM.YYYY'),
            task_type: '', // TODO
          };
          /* sendEVAMCustomEvent(EVAMSdkEventTypes.ABONMAN_YUKLEME, evamSdkData); */
          if (isUserAddingNewCardInTransactions) {
            let evamSdkData = {
              customer_no: userData.customerNumber,
              kart_id: cardState?.activeSelectedCard?.CardId,
              tarih: moment(new Date()).format('DD.MM.YYYY'),
              kanal: 'web', // TODO
            };
            /* sendEVAMCustomEvent(EVAMSdkEventTypes.HIZLI_ISLEM_ILE_BASKA_ISTANBUL_KARTA_ABONMAN_YUKLEME, evamSdkData); */
          }
        }
        if (isUserInAutomatiInstructionProcess) {
          yield put(setAutomaticInstructionStep(2));
        }
        if (pathname === routePath.cardApplicationSteps) {
          yield put(
            replace(routePath.cardApplicationUpdateSuccess, {
              pc: applicationCard?.ProductCode,
              id: updateApplicationId,
              isApplication: true,
              fromCenter: !isShipping,
              campusId: campusId,
            })
          );
          yield put(resetCardApplicationStatus());
          // if (cardApplicationStatus === 6) {
          //   const resendCustomerCardResult: ResendCustomerCardModel = yield call(() =>
          //     resendCustomerCard({
          //       CustomerNumber: userData?.customerNumber,
          //       ProductCode: applicationCard?.ProductCode,
          //     })
          //   );
          //   console.log('resendCustomerCardResult', resendCustomerCardResult);
          // }
          /* İKİNCİ KARGO SÜRECİNDE resendCustomerCard servisini iletmişlerdi ama sonrasında kullanılmadı. 
          Sonra kullanılabilmesi durumu için yorum satırında bırakıyorum.*/
        }
      } else if (
        vsPosBelbimPaymentResult.data.BankResponseMessage === '-' &&
        !vsPosBelbimPaymentResult.data.IsSuccess
      ) {
        //KULLANICI HALA 3D EKRANINDA
      } else {
        yield put(close3DSecureModal());
        yield put(showToastify({ toastMessage: vsPosBelbimPaymentResult.data.BankResponseMessage, type: 'error' }));
        yield put(vsPosBelbimPaymentRequestFail(vsPosBelbimPaymentResult.data.BankResponseMessage));
      }
    } else {
      console.log(errorMessage);
    }
  } catch (error: any) {
    yield put(showToastify({ toastMessage: staticErrorMessage, type: 'error' }));
    yield put(vsPosBelbimPaymentRequestFail(error));
  }
}

function* handleOnGetCommissionByBinNumberRequest({ payload }: PayloadAction<onGetCommissionByBinNumberReqBodyData>) {
  const cardState: CardTransactionsState = yield select(storeCardTransactions);
  const { isUserInUploadTLProcess, isUserInUploadSubscriptionProcess } = cardState;
  try {
    const onGetCommissionByBinNumberResult: OnGetCommissionByBinNumberModel = yield call(() =>
      onGetCommissionByBinNumber(payload)
    );

    const { responseCode, requestSuccess, errorMessage } = isBelbimRequestSuccess(onGetCommissionByBinNumberResult);

    if (requestSuccess) {
      yield put(onGetCommissionByBinNumberRequestSuccess(onGetCommissionByBinNumberResult.data.CommissionAmount));
    } else {
      yield put(onGetCommissionByBinNumberRequestFail(errorMessage));
      if (isUserInUploadTLProcess) {
        yield put(
          setFormError({
            errorCode: responseCode,
            formName: formNames.addBalanceToCard,
          })
        );
      }
      if (isUserInUploadSubscriptionProcess) {
        yield put(
          setFormError({
            errorCode: responseCode,
            formName: formNames.uploadSubscription,
          })
        );
      }
    }
  } catch (error: any) {
    yield put(onGetCommissionByBinNumberRequestFail(error));
  }
}

function* handleGetBinListRequestSaga({ payload }: PayloadAction<getBinListReqBodyData>) {
  try {
    const GetBinListModelResult: GetBinListModel = yield call(() => getBinList(payload));

    const { requestSuccess, errorMessage } = isBelbimRequestSuccess(GetBinListModelResult);

    if (requestSuccess) {
      yield put(getBinListRequestSuccess(GetBinListModelResult));
    } else {
      yield put(getBinListRequestFail(errorMessage));
    }
  } catch (error: any) {
    yield put(getBinListRequestFail(error));
  }
}

/**
 * Mobil WebView (React Native) akışlarının Masterpass giriş noktası.
 *
 * ⚠️ Bu handler `window.ReactNativeWebView.postMessage` ile native uygulamaya
 * mesaj gönderir — payload alan adları RN tarafıyla SÖZLEŞMEDİR ve bozulursa
 * mobil uygulama sessizce kırılır. SDK v1.0.7 geçişinde bu sözleşme korunmuş,
 * yalnızca değerlerin OKUNDUĞU yerler yeni cevap şemasına uyarlanmıştır:
 *
 *   `res.responseCode`        → `getMasterpassResponseCode(res)`
 *   `res.responseDescription` → `getMasterpassResponseDescription(res)`
 *   `res.url3D`               → `res.url3d`   (küçük d)
 *   `res.url3DSuccess/Error`  → `FlowDirectable.url3dSuccess / url3dFail`
 *
 * ⚠️ `url3DSuccess` / `url3DError` alanları artık cevabın gövdesinde değil,
 * SDK'nın akış durumunda (`FlowDirectable`) tutuluyor.
 */
function* handleOnGetMasterpassForMobileRequest({ payload }: PayloadAction<MasterPassTokenActionType | any>) {
  try {
    const { request } = payload;

    // Mobil akışta token, WebView'i açan native taraftan parametre olarak gelir;
    // burada token servisi hiç çağrılmaz.
    //
    // ⚠️ SÜRÜM BİLGİSİ MOBİLDE HENÜZ TAŞINMIYOR. Web'de sürümü token cevabındaki
    // `IsVersion2Active` söylüyor; mobil token'ı o cevabı görmeden aldığı için
    // burada aynı bayrak yok. Bilinen son sürüm (varsa) kullanılır, yoksa v2'ye
    // düşülür — bugünkü davranış budur.
    //
    // Mobil tarafta v1'e de geçilebilmesi için native uygulamanın token ile
    // birlikte sürüm bilgisini de iletmesi gerekir (`payload.isVersion2Active`);
    // alan geldiğinde aşağıdaki `?? 'v2'` yerine o okunmalıdır.
    const phoneNumberForMobile = payload?.request?.phoneNumberForMobile ?? '';
    const cardStore: CreditCardTransactionsState = yield select(creditCardTransactionsStore);

    // Sürüm önceliği: native'in ilettiği bayrak → bilinen son sürüm → v2.
    // ⚠️ Native taraf token'ı `RI.OnGenerateTLVToken` cevabından aldığı için
    // `IsVersion2Active` değerine zaten sahiptir; WebView adresine eklemesi
    // yeterli. Bayrak gelmediği sürece mobil akış v1'e HİÇ geçemez.
    // ⚠️ VARSAYILAN 'v1' — 'v2' DEĞİL. Sahada kalan eski uygulama sürümleri bu
    // bayrağı hiç göndermeyecek; varsayılan v2 olursa o istemciler kalıcı olarak
    // yanlış SDK'ya düşer. v1 eski ve hâlâ geçerli davranıştır.
    //
    // Öncelik: payload → store (ekran açılışında `setMasterpassVersion` ile
    // yazılır) → v1.
    const mobileVersion =
      payload?.isVersion2Active === undefined || payload?.isVersion2Active === null
        ? cardStore.masterpassVersion ?? 'v1'
        : toMasterpassVersion(payload.isVersion2Active === true || payload.isVersion2Active === 'true');
    const adapter = getMasterpassAdapter(mobileVersion);

    // ⚠️ v1 her isteğe `referenceNo` koyduğu için bağlam mobilde de geçilmeli;
    // native token ile birlikte referans numarasını da iletiyorsa oradan gelir.
    const session = adapter.authorize({
      token: payload?.jwt ?? payload?.token,
      phone: phoneNumberForMobile,
      customerNumber: payload?.CustomerNumber ?? payload?.customerNumber,
      context: {
        referenceNo: payload?.reqRefNumber ?? payload?.referenceNo,
        orderNo: payload?.paymentNumber ?? payload?.orderNo,
        terminalGroupId: payload?.macroMerchantId,
        returnUrl: payload?.returnUrl,
      },
    });
    const claims = session?.claims;
    const accountKeyType: MasterpassAccountKeyType = session?.accountKeyType ?? 'Msisdn';
    const accountKey = session?.accountKey ?? phoneNumberForMobile;
    const userId = session?.userId ?? phoneNumberForMobile;

    switch (payload.TokenType) {
      case MasterPassTokenEnum.REGISTER:
        adapter.addCard(
          {
            accountKey,
            accountKeyType,
            userId,
            cardNumber: request.data.cardNumber ?? '',
            expiryDate: request.data.expiryDate ?? '',
            cvv: request.data.cvv ?? '',
            accountAliasName: request.data.accountAliasName ?? '',
            cardHolderName: request.data.cardHolderName,
            // Mobil akışta referans URL parametresiyle (`reqRefNumber`) geliyor;
            // gelmediğinde zorunlu alanı boş bırakmamak için üretiliyor.
            // ⚠️ `??` DEĞİL `||`: mobil WebView `reqRefNumber || ''` ile BOŞ STRING
            // gönderiyor (v2 cevabında `ReqRefNumber` hiç gelmiyor) ve `??` boş
            // string'i geçerli sayıp üreticiyi atlıyor.
            requestReferenceNumber: request.data.requestReferenceNumber || generateRequestReferenceNumber(),
            additionalParams: request.data.additionalParams,
          },
          (_, response) => {
            // Web akışıyla aynı: kart kaydında `5010` da OTP adımı sayılır.
            if (isMasterpassCardRegistrationOtpRequired(response)) {
              window?.ReactNativeWebView?.postMessage(
                JSON.stringify({
                  cardNumber: request?.data?.cardNumber,
                  expireDate: request?.data?.expiryDate,
                  cvv: request?.data?.cvv,
                  cardName: request?.data?.accountAliasName,
                  processDone: false,
                })
              );
              resultChannel.put(showOTPDialog());
              resultChannel.put(onGetMasterpassForMobileRequestSuccess());
            } else {
              const errorMessage = getMasterpassResponseDescription(response);
              const errorCode = getMasterpassResponseCode(response);

              // ⚠️ TEŞHİS — KART EKLEME HATASI.
              //
              // `CAN_NOT_DECRYPT_CARDNUMBER` alınıyor. Şifrelemeyi SDK kendi
              // yapıyor (`encrypt(cardNumber)`), ama şifrelenen DEĞER bizden
              // geliyor: PAN boşluklu ya da maskeli giderse sunucu çözdüğünde
              // geçerli bir kart numarası bulamaz.
              //
              // ⚠️ PAN'IN KENDİSİ YAZILMAZ — yalnız uzunluğu ve boşluk içerip
              // içermediği. Bu log native cihaz loglarına düşüyor.
              window?.ReactNativeWebView?.postMessage(
                JSON.stringify({
                  errorMessage,
                  errorCode,
                  istek: {
                    surum: adapter.version,
                    accountKey,
                    expiryDate: request.data.expiryDate,
                    kartAdi: request.data.accountAliasName,
                  },
                  // ⚠️ ASIL DEĞERLİ ALAN BU. Sunucunun `exception.details` alanı
                  // hatanın hangi bacaktan geldiğini söylüyor
                  // (örn. "CryptographyService error." ya da
                  //  "registration/authorize → Vpos/auth-3d-secure").
                  //
                  // PAN'ın uzunluğu/boşluğu ÖLÇÜLMEZ: SDK boşlukları kendisi
                  // siliyor ve Luhn'dan geçmeyen numarada senkron `throw` edip
                  // isteği hiç göndermiyor. HTTP 400 alınıyor olması, PAN'ın
                  // zaten temiz ve geçerli gittiğinin kanıtı.
                  hataDetay: response?.exception ?? null,
                  iz: getMasterpassErrorTrace(response),
                })
              );
              resultChannel.put(onGetMasterpassForMobileRequestFail(errorMessage));
              resultChannel.put(
                setFormError({
                  errorCode: errorMessage,
                  formName: formNames.mobileAddCreditCard,
                })
              );
              resultChannel.put(
                setFormError({
                  errorCode: errorMessage,
                  formName: formNames.mobileAddCreditCardPlusCardApplication,
                })
              );
            }
          }
        );
        break;

      case MasterPassTokenEnum.LINK:
        adapter.linkToMerchant({ accountKey, userId }, (_, response) => {
          const responseCode = getMasterpassResponseCode(response);
          const isVerificationStep =
            isMasterpassOtpRequired(response) || responseCode === '5007' || responseCode === '5013';

          if (isVerificationStep) {
            resultChannel.put(
              replace(routePath.mobileAccountOtp, {
                json: JSON.stringify(response),
                lang: request.data.sendSmsLanguage,
              })
            );
            resultChannel.put(setLoadingForMasterpass(false));
          } else {
            const errorMessage = getMasterpassResponseDescription(response);

            window?.ReactNativeWebView?.postMessage(
              JSON.stringify({
                processDone: false,
                errorMessage,
              })
            );
            resultChannel.put(
              setFormError({
                errorCode: errorMessage,
                formName: formNames.mobileAddCreditCard,
              })
            );
            resultChannel.put(
              setFormError({
                errorCode: errorMessage,
                formName: formNames.mobileAddCreditCardPlusCardApplication,
              })
            );
            resultChannel.put(setLoadingForMasterpass(false));
          }
        });
        break;

      case MasterPassTokenEnum.OTP:
        adapter.verifyOtp(request.data, (_, res) => {
          if (isMasterpassSuccess(res)) {
            window?.ReactNativeWebView?.postMessage(
              JSON.stringify({
                processDone: true,
                isCardAddedWithMasterpass: true,
              })
            );
            resultChannel.put(closeOTPDialog());
            resultChannel.put(onGetMasterpassForMobileRequestSuccess());
          } else {
            const errorMessage = getMasterpassResponseDescription(res);
            const errorCode = getMasterpassResponseCode(res);

            window?.ReactNativeWebView?.postMessage(JSON.stringify({ errorMessage, errorCode }));
            resultChannel.put(
              setFormError({
                errorCode: errorMessage,
                formName: formNames.dialogOTP,
              })
            );
            resultChannel.put(onGetMasterpassForMobileRequestFail(errorMessage));
          }
        });
        break;

      case MasterPassTokenEnum.RESEND_OTP:
        adapter.resendOtp((_, res) => {
          if (!isMasterpassOtpRequired(res)) {
            resultChannel.put(
              setFormError({
                errorCode: getMasterpassResponseDescription(res),
                formName: formNames.dialogOTP,
              })
            );
          }
        });
        resultChannel.put(onGetMasterpassForMobileRequestSuccess());
        break;

      case MasterPassTokenEnum.REGISTER_PURCHASE: {
        const formattedDate = formatDate(new Date());
        const activeSelectedCard = payload.activeSelectedCreditCard;
        delete payload.activeSelectedCreditCard;
        const data = request?.data;

        // ⚠️ Web akışıyla aynı: sipariş bilgisi yapılandırılmış bloklarla gider.
        const paymentDetails = masterPassPaymentDetailsNormalize({
          amount: data?.amount ?? 0,
          name: data?.name,
          surname: data?.surname,
          email: data?.email,
          phoneNumber: data?.phoneNumber,
          formattedDate,
        });

        const basePaymentRequest = {
          accountKey,
          amount: data?.amount ?? 0,
          orderNo: payload?.PaymentNumber,
          // ⚠️ `??` DEĞİL `||`, ve YEDEK ÜRETİCİ ŞART.
          // v2 token cevabında `ReqRefNumber` HİÇ GELMİYOR (v1'de geliyordu);
          // panda da onu `referenceNo` olarak boş/undefined iletiyor. Referans
          // numarası olmadan Masterpass ödemeyi reddediyor ve kullanıcıya
          // jenerik "bilgilerinizi kontrol edin" uyarısı çıkıyor.
          // ⚠️ MOBİL ÖDEME GÖVDESİ WEB İLE BİREBİR AYNI TUTULUR.
          //
          // Web ödemesi çalışıyor ve gövdesinde `requestReferenceNo` ile
          // `paymentType` YOK. Bir dönem mobilde ikisi de gönderiliyordu:
          //   · `paymentType: 'DIRECT_PAYMENT'` → v1'den kalma, v2'de geçersiz.
          //     `PaymentType` enum'unun yalnızca `sale` ve `preAuth` değerleri var
          //     (SDK arayüzünden doğrulandı); geçersiz değer isteği reddettiriyor,
          //     `5010` dönmüyor ve 3D sayfası hiç açılmıyor.
          //   · `requestReferenceNo` → ödeme akışında gerekli değil; web onsuz
          //     çalışıyor. (Kart EKLEME akışında gerekli, orası ayrı.)
          //
          // Çalışan akıştan sapmamak için ikisi de kaldırıldı.
          ...paymentDetails,
          // ⚠️ TERMİNAL GRUBU BELBİM'İN TOKEN CEVABINDAN GELMELİ.
          //
          // v2'de `MacroMerchantId` ÜYE İŞYERİ kimliğini (`34705878`) taşıyor,
          // terminal grubunu değil — o yüzden ondan OKUNMAZ. Doğru alan
          // `MpTerminalGroupId`; panda bunu şifreli gövdede iletiyor.
          //
          // ⚠️ SABİT YEDEK SON ÇARE. Alan bir dönem hiç iletilmiyordu ve her
          // ödeme genel terminale gidiyordu: TL yüklemede iki değer aynı olduğu
          // için fark edilmedi, kart başvurusu ise KENDİ POS'unda koştuğu için
          // `5177 — Sadece Sandbox kredi kartları ile ödeme yapılabilir` aldı.
          //
          // ⚠️ ZİNCİRİN ORTA HALKASI ŞART. Yalnızca `MpTerminalGroupId → sabit`
          // bırakıldığında, o alanı göndermeyen SAHA SÜRÜMLERİ doğrudan sabite
          // düşüyor: kart başvurusu ödemesi genel terminale gidip Masterpass'ten
          // `Terminal group ID in the request is different from the terminal
          //  group ID provided in the orginal transaction` alıyor. Eski sürümler
          // `macroMerchantId`'yi HER ZAMAN iletiyor ve v1'de bu alan terminal
          // grubunu taşıyor (canlı TLV cevabında iki alan da
          // `06580638917902618286577` dönüyor) — bu yüzden güvenli yedektir.
          //
          // ⚠️ SADECE v1'DE OKUNUR: v2'de `MacroMerchantId` ÜYE İŞYERİ kimliğini
          // taşıyor, terminal grubunu değil. v2 istemcileri zaten
          // `MpTerminalGroupId` gönderdiği için yedek onlarda hiç devreye girmez.
          //
          // Web'in kendi akışındaki zincirle aynı sıradadır (bkz. ~676).
          terminalGroupId:
            payload?.MpTerminalGroupId ??
            (mobileVersion === 'v1' ? payload?.macroMerchantId : undefined) ??
            defaultTerminalGroupId(),
          ...(claims?.AuthenticationMethod ? { authenticationMethod: claims.AuthenticationMethod } : {}),
          ...(claims?.Secure3dType ? { secure3DModel: claims.Secure3dType } : {}),
          ...(claims?.CurrencyCode ? { currencyCode: claims.CurrencyCode } : {}),
        };

        const onPaymentResponse = (_: number, res: any) => {

          if (getMasterpassResponseCode(res) === MasterpassResponseCodeEnum.THREE_D_REDIRECT) {
            // ⚠️ `returnUrl` YOKSA ADRESE HİÇ EKLENMEZ.
            //
            // Daha önce doğrudan yazılıyordu ve alan boş olduğunda adres
            // `...&returnUrl=undefined` oluyordu. Masterpass 3D sonucunu o
            // adrese POST ediyor, Belbim sunucusu da doğal olarak "404 - File or
            // directory not found" dönüyordu — kullanıcı ödeme ekranında IIS
            // hata sayfası görüyordu.
            //
            // ⚠️ Alan ÖDEME token'ının cevabında geliyor (canlı log ile doğrulandı:
            // `MPVposReturnUrl.aspx`). Kart listesi token'ında gelmemesi normaldir —
            // o akışta 3D yoktur. Yine de savunma bırakıldı: adres boşsa parametre
            // hiç eklenmez, çünkü `undefined` yazıldığında Masterpass sonucu
            // geçersiz adrese POST edip Belbim tarafında 404 üretiyordu.
            const returnUrl = payload?.returnUrl;

            if (!returnUrl) {
              console.error(
                '[Masterpass] 3D dönüş adresi (`ReturnUrl`) yok — ödeme tamamlanamaz. ' +
                  'Token servisinin cevabında `ReturnUrl` alanı bekleniyor.'
              );
            }

            // ⚠️ HAM GÖNDERİLİR, encodeURIComponent İLE DEĞİL.
            // Web ödeme akışı da ham gönderiyor ve çalışıyor
            // (`&returnUrl=${jwtResponse?.data?.ReturnUrl}`). Kodlanmış hâli
            // Masterpass tarafında çözülmezse adres bozulur. Kart KAYDI akışında
            // kodlama kullanılıyor ama orası ayrı bir uç (kendi statik sayfamız).
            const newUrl = returnUrl ? `${res.url3d}&returnUrl=${returnUrl}` : res.url3d;
            const flow = adapter.flow3d();

            window?.ReactNativeWebView?.postMessage(
              JSON.stringify({
                status: 'success',
                url3D: newUrl,
                // ⚠️ Bu iki alan artık cevabın gövdesinde değil, SDK'nın akış durumunda.
                url3DError: flow?.url3dFail,
                url3DSuccess: flow?.url3dSuccess,
              })
            );
          } else {
            window?.ReactNativeWebView?.postMessage(
              JSON.stringify({
                status: 'error',
                response: getMasterpassResponseDescription(res),
                // Teşhis için ham kod ve GİDEN GÖVDE de iletiliyor; panda bunları
                // native konsola yazıyor. WebView konsoluna erişmeden sorunun
                // istekte mi cevapta mı olduğunu ayırt etmenin tek pratik yolu.
                responseCode: getMasterpassResponseCode(res),
                istek: requestDiagnostics,
                // ⚠️ Masterpass destek kayıtlarında İSTENEN alanlar. Korelasyon
                // kimliği olmadan işlemi kendi loglarında bulamıyorlar.
                iz: getMasterpassErrorTrace(res),
              })
            );
          }
        };

        // ⚠️ TEŞHİS ÖZETİ — HATA MESAJIYLA BİRLİKTE NATIVE TARAFA GÖNDERİLİR.
        // WebView konsoluna erişmek cihazda zahmetli olduğu için giden gövdenin
        // kritik alanları `postMessage` ile native loglara taşınıyor.
        const requestDiagnostics = {
          // Hangi adaptörün çalıştığı artık düz kanıt olarak loglara düşüyor.
          surum: adapter.version,
          amount: basePaymentRequest.amount,
          orderNo: basePaymentRequest.orderNo,
          terminalGroupId: basePaymentRequest.terminalGroupId,
          cardAlias: activeSelectedCard?.cardAlias ?? data?.cardAlias,
          kayitsizKart: !!activeSelectedCard?.cardNumber,
        };

        if (activeSelectedCard?.cardNumber) {
          // ⚠️ 3D bitişinde ne yapılacağı bu ayrıma bağlı: SDK demolarında
          // `completeRegistration` YALNIZCA `directPayment` akışında çağrılıyor.
          resultChannel.put(setThreeDSecureFlow('directPayment'));
          adapter.directPayment(
            {
              ...basePaymentRequest,
              cardNumber: activeSelectedCard.cardNumber,
              expiryDate: activeSelectedCard.expiryDate,
              cvc: activeSelectedCard.cvv,
              cardAlias: activeSelectedCard.cardAlias,
            },
            onPaymentResponse
          );
        } else {
          resultChannel.put(setThreeDSecureFlow('payment'));
          adapter.payment(
            {
              ...basePaymentRequest,
              cardAlias: activeSelectedCard?.cardAlias ?? data?.cardAlias ?? '',
              cvc: activeSelectedCard?.cvv ?? data?.cvc,
            },
            onPaymentResponse
          );
        }
        break;
      }

      // ⚠️ Eski `initiateRecurringPayment` tek metottu; işlem `actionType` ile
      // (`'A'` ekle / `'D'` sil) belirleniyor, "talimat zaten var" (4152) hatasında
      // önce silinip sonra yeniden ekleniyordu. Yeni SDK'da ekleme ve silme AYRI
      // METOTLAR olduğu için aynı davranış açıkça kodlanmıştır.
      case MasterPassTokenEnum.INITIATE_RECURRING_PAYMENT: {
        const recurringRequest = {
          accountKey,
          // ⚠️ `authenticationMethod` TALİMAT İSTEĞİNE KONULMAZ — DENENDİ, BOZDU.
          //
          // Masterpass'in resmi demosu bu alanı JWT'den doldurup gönderiyor
          // (Masterpass-web-sdk-main/demo/pages/recurringOrder.html), o yüzden
          // eklenmişti. Ama BİZİM talimat token'ımızda claim'in değeri literal
          // `'None'` ve bu değerle gönderildiğinde servis üç yönde de (A/U/D)
          // HTTP 401 dönüyor — daha önce çalışan TALİMAT OLUŞTURMA da kırıldı.
          //
          // Alan gönderilmediğinde servis kendi varsayılanını kullanıyor ve
          // oluşturma çalışıyor. Belbim talimat token'ına anlamlı bir
          // `AuthenticationMethod` claim'i koyana kadar bu alan GÖNDERİLMEYECEK.
          cardAlias: request.data.cardAlias ?? '',
          amountLimit: request.data.amountLimit,
          expiryDate: request.data.expiryDate,
          productId: request.data.productId,
          // Talimat servisleri de aynı zorunlu referans alanını istiyor.
          // ⚠️ `??` DEĞİL `||`. Çağıranlar referans numarasını BOŞ STRING olarak
          // gönderebiliyor (mobil WebView `reqRefNumber || ''` yapıyor ve v2 cevabında
          // `ReqRefNumber` hiç gelmiyor). `??` boş string'i geçerli sayıp üreticiyi
          // atlıyor, Masterpass da "Request Reference Number boş olmamalı" diyor.
          requestReferenceNumber: request.data.requestReferenceNumber || generateRequestReferenceNumber(),
          // ⚠️ v1 (MFS) gövdesi bu alanı bekliyor; v2 SDK'sı whitelist'te
          // olmadığı için sessizce siliyor. İki sürüm için de güvenli.
          ...(request.transactionFee ? { transactionFee: request.transactionFee } : {}),
        };

        const onRecurringResponse = (_: number, response: any) => {
          const responseCode = getMasterpassResponseCode(response);

          if (isMasterpassSuccess(response)) {
            // ⚠️ Başarı dalı da kodu taşır. "Ekleme çalışıyor" kanıtımız bugüne
            // kadar Belbim listesinde satırın belirmesiydi — ama o liste
            // Masterpass'ten değil Belbim'den geliyor. Masterpass'in gerçekten
            // 0000 döndüğünü görmek için kod buraya yazılıyor.
            window?.ReactNativeWebView?.postMessage(
              JSON.stringify({
                processDone: true,
                kod: responseCode,
                yon: request.recurringActionType,
                iz: getMasterpassErrorTrace(response),
              })
            );
            return;
          }

          if (isMasterpassOtpRequired(response)) {
            window?.ReactNativeWebView?.postMessage(JSON.stringify({ processDone: false }));
            resultChannel.put(showOTPDialog());
            resultChannel.put(onGetMasterpassForMobileRequestSuccess());
            return;
          }

          if (responseCode === MasterpassResponseCodeEnum.RECURRING_ALREADY_EXISTS) {
            // Talimat zaten var: önce sil, silme başarılıysa yeniden oluştur.
            adapter.recurringOrderDelete(recurringRequest, (__, deleteResponse) => {
              if (isMasterpassSuccess(deleteResponse)) {
                adapter.recurringOrder(recurringRequest, onRecurringResponse);
              } else {
                const errorMessage = getMasterpassResponseDescription(deleteResponse);
                window?.ReactNativeWebView?.postMessage(
                  JSON.stringify({
                    processDone: false,
                    errorMessage,
                    errorCode: getMasterpassResponseCode(deleteResponse),
                  })
                );
                resultChannel.put(onGetMasterpassForMobileRequestFail(errorMessage));
              }
            });
            return;
          }

          const errorMessage = getMasterpassResponseDescription(response);
          // ⚠️ TEŞHİS — A/U/D ORTAK HATA DALI.
          //
          // Ekleme, güncelleme ve silme aynı yerden hata döndürüyor ve hangi fiile
          // düştüğü hiçbir yere yazılmıyordu; "Düzenleme emri bulunamadı" ile
          // "Kimlik doğrulama başarısız oldu" mesajlarının hangi işlemden geldiği
          // sahada ayırt edilemiyordu.
          //
          // Masterpass talimatı `accountKey + cardAlias + productId` üçlüsüyle
          // buluyor (SDK bundle'ı: /account/api/RecurringOrder, kayda özel bir
          // orderId alanı yok). Bu üç değer ile `iz` içindeki HTTP kodu ve
          // correlationId, iki hatayı birbirinden ayırmaya yetiyor:
          //   404/kayıt yok  -> kimlik eşleşmiyor ya da kayıt v2 tarafında yok
          //   401/403        -> fiil bazlı yetki (POST açık, PUT/DELETE kapalı)
          window?.ReactNativeWebView?.postMessage(
            JSON.stringify({
              processDone: false,
              errorMessage,
              errorCode: responseCode,
              istek: {
                surum: adapter.version,
                yon: request.recurringActionType,
                // Resmi Masterpass demosu bu alanı JWT claim'inden doldurup
                // gönderiyor; bizde eksikti. Düzeltmenin sahada etkin olup
                // olmadığı ancak burada görülüyor — boş görünüyorsa deploy
                // henüz çıkmamış ya da JWT claim'i boş demektir.
                // İstekte GÖNDERİLMİYOR; yalnız JWT'nin ne dediğini görmek için.
                jwtAuthenticationMethod: claims?.AuthenticationMethod ?? '(claim yok)',
                accountKey: recurringRequest.accountKey,
                cardAlias: recurringRequest.cardAlias,
                productId: recurringRequest.productId,
                amountLimit: recurringRequest.amountLimit,
                expiryDate: recurringRequest.expiryDate,
                requestReferenceNumber: recurringRequest.requestReferenceNumber,
              },
              iz: getMasterpassErrorTrace(response),
              // ⚠️ HAM `exception` GÖVDESİ. Ödeme ve kart ekleme arızalarını
              // çözen alan buydu: `details` içinde sunucunun hangi iç servisinde
              // takıldığı yazıyor (örn. "CryptographyService error." ya da
              // 503 dönen iç servisin adresi). Tek satırlık `iz` özeti bunu
              // taşımıyor.
              hataDetay: response?.exception ?? null,
            })
          );
          resultChannel.put(onGetMasterpassForMobileRequestFail(errorMessage));
        };

        // ⚠️ ÜÇ YÖN DE AYRI. Eskiden yalnızca 'D' ayrılıyordu ve 'U' (güncelleme)
        // sessizce 'A' (ekleme) olarak gidiyordu — mevcut bir talimatı güncellemek
        // isteyen kullanıcı "talimat zaten var" hatasına düşüyordu.
        if (request.recurringActionType === 'D') {
          adapter.recurringOrderDelete(recurringRequest, onRecurringResponse);
        } else if (request.recurringActionType === 'U') {
          adapter.recurringOrderUpdate(recurringRequest, onRecurringResponse);
        } else {
          adapter.recurringOrder(recurringRequest, onRecurringResponse);
        }
        break;
      }
    }
    yield put(open3DSecureModal());
  } catch (error: any) {
    // ⚠️ MOBİL AKIŞTA HATA NATIVE TARAFA DA BİLDİRİLİR.
    //
    // Burası eskiden yalnızca web tarafında toast gösteriyordu; WebView içinde
    // toast kimse tarafından görülmüyor ve native uygulama hiçbir şey duymuyordu.
    // Sonuç: senkron bir exception WebView'i SESSİZCE ölü bırakıyor, kullanıcı
    // ekranda takılı kalıyor ya da sunucunun 404 sayfasına düşüyordu.
    //
    // Kayıtsız kart ödemesinde tam olarak bu yaşandı: hiçbir postMessage
    // gelmiyordu, dolayısıyla hatanın varlığı bile görünmüyordu.
    window?.ReactNativeWebView?.postMessage(
      JSON.stringify({
        status: 'error',
        response: error?.message ?? staticErrorMessage,
        responseCode: 'EXCEPTION',
      })
    );

    yield put(showToastify({ toastMessage: staticErrorMessage, type: 'error' }));
    yield put(vsPosBelbimPaymentRequestFail(error));
  }
}

// Watchers
/**
 * Kayıtlı kart listesini sunucudan tazeler.
 *
 * ⚠️ AYRI BİR ACTION'A BAĞLI OLMASI KASITLI: token isteklerini dinleyen watcher
 * `takeLatest` kullanıyor ve ekran geçişindeki her token isteği devam eden
 * tazelemeyi iptal ediyordu. Farklı action tipi = farklı `takeLatest` kuyruğu.
 */
function* handleRefreshCreditCardList() {
  const userData: UserState = yield select(userStore);

  yield call(handleGetMasterpassToken, {
    payload: {
      CustomerNumber: userData.customerNumber,
      SessionToken: userData.sessionToken,
      TokenType: MasterPassTokenEnum.CARD_LIST,
      forceRefresh: true,
      request: {
        data: masterPassListCardNormalize(),
      },
    },
  });
}

function* creditCardTransactionsSagaWatcher() {
  yield takeLatest(onGetMasterpassTokenRequest, handleGetMasterpassToken);
  yield takeLatest(refreshCreditCardListRequest, handleRefreshCreditCardList);
  yield takeLatest(onGetMasterpassForMobileRequest, handleOnGetMasterpassForMobileRequest);
  yield takeLatest(vsPosBelbimPaymentRequest, handleVsPosBelbimPaymentRequest);
  yield takeLatest(getBinListRequest, handleGetBinListRequestSaga);
  yield takeLatest(onGetCommissionByBinNumberRequest, handleOnGetCommissionByBinNumberRequest);
  yield takeLatest(checkPaymentStatusRequest, handleCheckVposPayment);
  yield takeLatest(cardRegistrationCompleted, handleCardRegistrationCompleted);
  yield takeLatest(recurringOrderCompleted, handleRecurringOrderCompleted);
  yield takeLatest(masterpass3DFlowCompleted, handleMasterpass3DFlowCompleted);
  while (true) {
    const action: PayloadAction = yield take(resultChannel);
    yield put(action);
  }
}

// eslint-disable-next-line
export default creditCardTransactionsSagaWatcher;
